import styles from "./banner.module.css";

export default function Banner({ callout = "", header = "", description = '', className = "" }) {
  return (
    <div className={className}>
      {callout !== "" && <div className={styles.callout}>{callout}</div>}
      {header !== "" && <div className={styles.header}>{header}</div>}
      {description !== "" && <div className={styles.description}>{description}</div>}
    </div>
  );
}
